/* eslint-disable no-unused-vars */
import React, { useState, useContext, useEffect } from "react";
import { Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { TextDecrypt } from "../content/TextDecrypt";
import { ThemeContext } from "../theme/ThemeProvider";

import './Works.css';

// Import project thumbnails
import StaticVilla from '../../assets/staticvilla-thumbnail.png';
import NutriGuide from '../../assets/nutriguide-thumbnail.png';
import CustomerCustomer from '../../assets/customercustomer.png';
import Datanu from '../../assets/imageannottool-thumbnail.png';
import Fitabra from '../../assets/fitabra-thumbnail.svg';
import Confana from '../../assets/confana-thumbnail.png';
import GdgCert from '../../assets/gdg_cert.jpeg';

// Import project videos
import StaticVillaVideo1 from '../../assets/videos/staticvilla1.mp4';
import StaticVillaVideo2 from '../../assets/videos/staticvilla2.mp4';
import NutriGuideVideo from '../../assets/videos/nutriguide.mp4';
import CustomerCustomerVideo from '../../assets/videos/customercustomer.mp4';
import DatanuVideo from '../../assets/videos/imageannottool.mp4';
import FitabraVideo from '../../assets/videos/fitabra.mp4';

const getYouTubeEmbedUrl = (url) => {
  if (!url) return '';
  const match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([\w-]{11})/);
  return match ? `https://www.youtube.com/embed/${match[1]}?autoplay=1&rel=0` : url;
};

const isYouTubeUrl = (url) => {
  return typeof url === 'string' && (url.includes('youtube.com') || url.includes('youtu.be'));
};

const useStyles = makeStyles((theme) => ({
  main: {
    maxWidth: '100vw',
    marginTop: '3em',
    marginBottom: "auto",
  },
}));

export const Works = () => {
  const classes = useStyles();
  const { theme } = useContext(ThemeContext);
  const [playingVideo, setPlayingVideo] = useState(null);
  const [currentVideoIndex, setCurrentVideoIndex] = useState({});
  const [isCertModalOpen, setIsCertModalOpen] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        setIsCertModalOpen(false);
      }
    };
    if (isCertModalOpen) {
      window.addEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  }, [isCertModalOpen]);
  
  const [projects, setProjects] = useState([
    { 
      id: 6,
      title: 'Confana', 
      year: '2026',
      description: `Confana is an all-in-one AI automation platform that enables businesses to build autonomous AI agents capable of performing real work 24/7. Instead of relying on simple chatbots or disconnected automation tools, Confana combines intelligent reasoning, workflow automation, browser control, voice AI, and powerful integrations into a single no-code platform. It enables building autonomous voice agents that communicate naturally in English and Ghanaian languages such as Twi and Ga, browser agents that navigate websites and complete forms, multi-step workflow automations, and 24/7 customer support agents across WhatsApp, Telegram, and websites.`,
      alter: 'Confana',
      image: `${Confana}`,
      videos: ['https://www.youtube.com/watch?v=qlsfIbcORA0'],
    },
    { 
      id: 1,
      title: 'Static Villa', 
      year: '2022',
      description: `Static Villa is a powerful website builder that enables you to create, edit, and clone existing websites with ease. It features an inbuilt code editor and an AI assistant that helps you write, debug, and optimize code instantly. It also supports drag-and-drop components, responsive layouts, and live preview for a smooth web design experience.`,
      alter: 'Static Villa',
      image: `${StaticVilla}`,
      videos: [`${StaticVillaVideo1}`, `${StaticVillaVideo2}`],
    },
    { 
      id: 2,
      title: 'NutriGuide AI', 
      year: '2023',
      description: `NutriGuide AI is an intelligent nutrition platform that helps people track their diet and achieve their nutrition goals. It allows clinics and health professionals to monitor patients remotely in low-resource communities using AI-driven tools. Users can simply take a picture of their food to instantly receive a full nutritional profile. The platform also integrates Automated Speech Recognition (ASR) for real-time transcription of local languages, breaking communication barriers. With multi-language voice interaction and mobile accessibility, NutriGuide AI works even on basic phones, no smartphone required.`,
      alter: 'NutriGuide AI',
      image: `${NutriGuide}`,
      videos: [`${NutriGuideVideo}`],
    },
      { 
      id: 3,
      title: 'Fitabra', 
      year: '2025',
      description: `Fitabra is an application that is used to find the nearest mechanic without the use of the internet, no smartphone needed and no language barrier, a basic mobile phone is okay. Remember that basic mobile phone don't have GPS but I used smart technics to do it.`,
      alter: 'Fitabra',
      image: `${Fitabra}`,
      videos: [`${FitabraVideo}`],
    },
    { 
      id: 4,
      title: 'CustomerCustomer', 
      year: '2025',
      description: `CustomerCustomer is like Google Maps for discovering nearby products, services, and job opportunities. It integrates real-time chat, user reviews, and AI-powered recommendations to connect people with local businesses and opportunities faster and more efficiently.`,
      alter: 'CustomerCustomer',
      image: `${CustomerCustomer}`,
      videos: [`${CustomerCustomerVideo}`],
    },
    { 
      id: 5,
      title: 'Datanu', 
      year: '2025',
      description: `Datanu is a versatile data collection and labeling platform built for AI projects. It supports NLP tasks and image classification workflows, from segmentation to bounding boxes, and provides collaborative tools for researchers, developers, and data annotators to manage high-quality datasets at scale.`,
      alter: 'Datanu',
      image: `${Datanu}`,
      videos: [`${DatanuVideo}`],
    },

  ]);

  const handlePlayVideo = (projectId) => {
    setPlayingVideo(playingVideo === projectId ? null : projectId);
    if (!currentVideoIndex[projectId]) {
      setCurrentVideoIndex({ ...currentVideoIndex, [projectId]: 0 });
    }
  };

  const handleNextVideo = (projectId, videosLength) => {
    setCurrentVideoIndex({
      ...currentVideoIndex,
      [projectId]: ((currentVideoIndex[projectId] || 0) + 1) % videosLength
    });
  };

  const handlePrevVideo = (projectId, videosLength) => {
    setCurrentVideoIndex({
      ...currentVideoIndex,
      [projectId]: ((currentVideoIndex[projectId] || 0) - 1 + videosLength) % videosLength
    });
  };

  return (
    <section id="works">
      <Container component="main" className={classes.main} maxWidth="xl">
        <div className="works-header">
          <h2 className="works-title">
            <TextDecrypt text="Featured Projects" />
          </h2>
          <p className="works-subtitle">A showcase of my recent work in web development, AI, and data solutions</p>
        </div>
        
        <div className="projects-container">
          {/* Certificate of Recognition Card - Positioned at the right part before the other projects */}
          <div className="project-card-horizontal reverse certificate-card">
            {/* Certificate Media placed on the right side */}
            <div className="project-media-laptop certificate-media-laptop">
              <div className="cert-frame-wrapper">
                <div 
                  className="cert-frame" 
                  onClick={() => setIsCertModalOpen(true)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => e.key === 'Enter' && setIsCertModalOpen(true)}
                  title="Click to view full certificate"
                >
                  <img 
                    src={GdgCert} 
                    alt="Certificate of Recognition - Prince Nii Y. Annan, Machine Learning Lead" 
                    className="cert-image"
                  />
                  <div className="cert-badge-floating">
                    <i className="fas fa-award"></i> Certificate of Recognition
                  </div>
                  <div className="cert-overlay">
                    <div className="cert-zoom-btn">
                      <i className="fas fa-search-plus"></i>
                    </div>
                    <span className="cert-overlay-text">Click to View Certificate</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Certificate Content placed on the left side */}
            <div className="project-content-horizontal certificate-content">
              <div className="project-header">
                <div className="cert-tags-row">
                  <span className="project-year cert-tag">
                    <i className="fas fa-award"></i> Leadership • 2025/2026
                  </span>
                  <span className="cert-tag org-tag">
                    <i className="fab fa-google"></i> GDG on Campus UCC
                  </span>
                </div>
                <h3 className="project-title">
                  <TextDecrypt text="Machine Learning Lead — GDG UCC" />
                </h3>
              </div>

              <div className="project-description certificate-description">
                <p>
                  As the Machine Learning Lead and Core Team Member for{" "}
                  <a href="https://www.linkedin.com/company/gdg-ucc/" target="_blank" rel="noopener noreferrer">
                    Google Developer Groups (GDG) on Campus - UCC
                  </a>{" "}
                  during the 2025/2026 academic year, I spearheaded the community's AI and machine learning initiatives to help developers build practical, real-world skills.
                </p>
                <p>
                  In this role, I designed and conducted technical workshops, led hands-on training sessions in machine learning workflows, and mentored peers through real-world AI implementations. I also actively managed community operations and collaborated with{" "}
                  <a href="https://www.linkedin.com/company/gdgaccra/" target="_blank" rel="noopener noreferrer">
                    GDG Accra
                  </a>{" "}
                  and our leadership team to organize developer programs and hackathons.
                </p>
                <p>
                  This certificate of recognition highlights my commitment to technical mentorship, community leadership, and empowering others to solve impactful problems through intelligent technology.
                </p>
              </div>

              <div className="project-actions">
                <button 
                  className={`action-button primary ${theme === 'light' ? 'light-mode' : ''}`}
                  onClick={() => setIsCertModalOpen(true)}
                >
                  <i className="fas fa-certificate"></i>
                  View Certificate
                </button>
                <a 
                  href="https://www.linkedin.com/company/gdg-ucc/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="action-button secondary-btn"
                >
                  <i className="fab fa-linkedin"></i>
                  GDG UCC
                </a>
                <a 
                  href="https://www.linkedin.com/company/gdgaccra/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="action-button secondary-btn"
                >
                  <i className="fab fa-linkedin"></i>
                  GDG Accra
                </a>
              </div>
            </div>
          </div>

          {projects.map((project, index) => (
            <div className={`project-card-horizontal ${index % 2 === 0 ? '' : 'reverse'}`} key={project.id}>
              <div className="project-media-laptop">
                <div className={`laptop-frame ${playingVideo === project.id ? 'video-playing' : ''}`}>
                  <div className={`laptop-screen ${playingVideo === project.id ? 'video-playing' : ''}`}>
                    {playingVideo === project.id ? (
                      <div className="video-player-wrapper">
                        {isYouTubeUrl(project.videos[currentVideoIndex[project.id] || 0]) ? (
                          <iframe
                            className="project-video"
                            src={getYouTubeEmbedUrl(project.videos[currentVideoIndex[project.id] || 0])}
                            title={`${project.title} Demo`}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen
                          ></iframe>
                        ) : (
                          <video 
                            className="project-video"
                            controls 
                            autoPlay
                            playsInline
                            key={currentVideoIndex[project.id] || 0}
                            onEnded={() => setPlayingVideo(null)}
                          >
                            <source src={project.videos[currentVideoIndex[project.id] || 0]} type="video/mp4" />
                            Your browser does not support the video tag.
                          </video>
                        )}
                        {project.videos.length > 1 && (
                          <div className="video-navigation">
                            <button 
                              className="video-nav-btn prev"
                              onClick={() => handlePrevVideo(project.id, project.videos.length)}
                            >
                              <i className="fas fa-chevron-left"></i>
                            </button>
                            <span className="video-counter">
                              {(currentVideoIndex[project.id] || 0) + 1} / {project.videos.length}
                            </span>
                            <button 
                              className="video-nav-btn next"
                              onClick={() => handleNextVideo(project.id, project.videos.length)}
                            >
                              <i className="fas fa-chevron-right"></i>
                            </button>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className="project-thumbnail-wrapper" onClick={() => handlePlayVideo(project.id)}>
                        <img 
                          src={project.image} 
                          alt={project.alter}
                          className="project-thumbnail"
                        />
                        <div className="play-overlay">
                          <div className="play-button">
                            <i className="fas fa-play"></i>
                          </div>
                          <span className="play-text">Watch Demo</span>
                          {project.videos.length > 1 && (
                            <span className="video-count-badge">{project.videos.length} videos</span>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="laptop-bottom">
                    <div className="laptop-bottom-inner"></div>
                  </div>
                </div>
              </div>
              
              <div className="project-content-horizontal">
                <div className="project-header">
                  <h3 className="project-title">
                    <TextDecrypt text={project.title} />
                  </h3>
                  <span className="project-year">Started {project.year}</span>
                </div>
                
                <p className="project-description">
                  {project.description}
                </p>
                
                <div className="project-actions">
                  <button 
                    className={`action-button primary ${theme === 'light' ? 'light-mode' : ''}`}
                    onClick={() => handlePlayVideo(project.id)}
                  >
                    <i className="fas fa-play-circle"></i>
                    {playingVideo === project.id ? 'Hide Demo' : 'View Demo'}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Certificate Lightbox Modal */}
        {isCertModalOpen && (
          <div 
            className="cert-modal-backdrop" 
            onClick={() => setIsCertModalOpen(false)}
          >
            <div 
              className="cert-modal-dialog" 
              onClick={(e) => e.stopPropagation()}
            >
              <button 
                className="cert-modal-close" 
                onClick={() => setIsCertModalOpen(false)}
                aria-label="Close certificate modal"
              >
                <i className="fas fa-times"></i>
              </button>
              <div className="cert-modal-header">
                <h4 className="cert-modal-title">
                  <i className="fas fa-award"></i> Certificate of Recognition
                </h4>
                <p className="cert-modal-subtitle">
                  Google Developer Groups on Campus • University of Cape Coast Chapter (2025/2026)
                </p>
              </div>
              <div className="cert-modal-body">
                <img 
                  src={GdgCert} 
                  alt="Certificate of Recognition - Prince Nii Y. Annan" 
                  className="cert-modal-image"
                />
              </div>
              <div className="cert-modal-footer">
                <span className="cert-recipient-name">
                  Awarded to: <strong>Prince Nii Y. Annan</strong>
                </span>
                <a 
                  href={GdgCert} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="action-button primary cert-open-btn"
                >
                  <i className="fas fa-external-link-alt"></i> Open Full Image
                </a>
              </div>
            </div>
          </div>
        )}
      </Container>
    </section>
  );
};
